import { zodResolver } from '@hookform/resolvers/zod';
import { PropsWithChildren } from 'react';
import { useForm } from 'react-hook-form';
import { Vehicle } from 'further-types/lp/vehicle';
import { realisation as rules } from 'further-ui/validations';
import { PartialRealisationAllocationLogic } from 'further-types/lp/realisation';
import FormWithStateContextProvider from 'contexts/FormWithStateContext';
import { RealisationFormState } from './types';

type Props = {
  selectedVehicle: Vehicle;
  values: rules.CreateRealisationFormValues;
};

export const defaultHoldingClassRealisation = {
  holdingClassId: '',
  name: '',
  unitsSold: 0,
  partialRealisationAllocationLogic: PartialRealisationAllocationLogic.ProRata,
  unitsAllocationPerInvestment: [],
  cashConsiderationAmounts: {
    receivedConsiderationPerUnit: 0,
    receivedConsiderationTotal: 0,
    escrowConsiderationPerUnit: 0,
    escrowConsiderationTotal: 0,
    earnoutConsiderationPerUnit: 0,
    earnoutConsiderationTotal: 0,
    withholdingTaxPayable: 0,
  },
};

const FormWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  values,
}) => {
  const formMethods = useForm({
    shouldFocusError: true,
    resolver: zodResolver(rules.CreateRealisationFormSchema),
    defaultValues: values,
    criteriaMode: 'all',
    resetOptions: {
      keepDefaultValues: false,
    },
  });

  // Initial state for the context
  const initialState: RealisationFormState = {
    consideration: values.consideration.map((_, index) => ({
      index,
      showAllocationsTable: false,
      disableAllocationsInputs: false,
      holdingClassInvestmentsConsiderationValues: [],
    })),
  };

  return (
    <FormWithStateContextProvider
      formMethods={formMethods}
      initialState={initialState}
    >
      {children}
    </FormWithStateContextProvider>
  );
};

export default FormWrapper;
